var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"height":_vm.timeScrollBarCanvasHeightPx}})
}
var staticRenderFns = []

export { render, staticRenderFns }